var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.385,
    height: 15.386,
    viewBox: "0 0 15.385 15.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9c044",
    d: "M14.4,0H.982A.982.982,0,0,0,0,.982V14.4a.983.983,0,0,0,.982.982H14.4a.983.983,0,0,0,.982-.982V.982A.983.983,0,0,0,14.4,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.69 6.228)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "0.3px",
    d: "M5.953,7.386a4.245,4.245,0,0,1-.122,1.093,1.819,1.819,0,0,1-.368.731,1.442,1.442,0,0,1-.614.41,2.557,2.557,0,0,1-.856.13,2.133,2.133,0,0,1-.776-.135,1.624,1.624,0,0,1-.591-.386,1.715,1.715,0,0,1-.376-.609,2.284,2.284,0,0,1-.132-.8V7.63H3.04q0,1.287.954,1.287a1.478,1.478,0,0,0,.435-.058.667.667,0,0,0,.323-.221,1.1,1.1,0,0,0,.2-.45,3.362,3.362,0,0,0,.069-.755v-4.8h.932V7.386ZM11.1,8.78a1.546,1.546,0,0,1-.4.509,1.938,1.938,0,0,1-.639.34,2.748,2.748,0,0,1-.843.121q-2.065,0-2.177-1.631h.906q.006.922,1.262.922A1.772,1.772,0,0,0,9.7,8.978a1.067,1.067,0,0,0,.357-.169.734.734,0,0,0,.217-.255.7.7,0,0,0,.074-.319.652.652,0,0,0-.056-.291.489.489,0,0,0-.218-.2,2.378,2.378,0,0,0-.447-.166q-.286-.084-.747-.2c-.3-.074-.559-.149-.775-.223a1.854,1.854,0,0,1-.535-.269.974.974,0,0,1-.311-.392,1.492,1.492,0,0,1-.1-.589,1.287,1.287,0,0,1,.132-.58,1.358,1.358,0,0,1,.379-.464,1.837,1.837,0,0,1,.6-.307,2.566,2.566,0,0,1,.779-.111q2,0,2.029,1.42h-.89q-.048-.709-1.07-.71a1.865,1.865,0,0,0-.421.045,1.175,1.175,0,0,0-.336.13.657.657,0,0,0-.223.209.529.529,0,0,0-.079.289.679.679,0,0,0,.037.243.384.384,0,0,0,.178.178,1.945,1.945,0,0,0,.416.162q.275.08.753.2.461.111.8.23a2.11,2.11,0,0,1,.564.289,1.041,1.041,0,0,1,.334.413,1.509,1.509,0,0,1,.108.609A1.431,1.431,0,0,1,11.1,8.78Z",
    transform: "translate(-2.118 -2.635)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsSm);
export default __webpack_public_path__ + "static/media/js-sm.924314a5.svg";
export { ForwardRef as ReactComponent };